import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { UserModel } from 'app/_models/user-model';
import { LoginModel } from 'app/_models/login-model';
import { ApiManagerService } from './api-manager.service';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { EncryptionService } from './encryption.service';
import { map, tap } from 'rxjs/operators';
 

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private readonly currentUserSource = new ReplaySubject<UserModel>(1);
  currentUser$ = this.currentUserSource.asObservable();
  private httpClient: HttpClient;
  _baseUrl = environment.baseUrl;

  constructor(private readonly apiManager: ApiManagerService,
    private readonly httpBackend: HttpBackend,
    private readonly http: HttpClient, 
    private readonly router: Router,
    private readonly encryptDecryptService:EncryptionService,
  ) { 
      this._baseUrl = environment.baseUrl;
    }

  login(model: LoginModel) {
    this.httpClient = new HttpClient(this.httpBackend);
    return this.httpClient.post(`${this._baseUrl}account/login`, model).pipe(
      map((response: UserModel) => {
        const user = response;
      
        if (user) {
          const decodedToken = jwtDecode(user.token);

          user.sessionId= decodedToken["sessionId"];
          sessionStorage.setItem('user', JSON.stringify(user));
          this.currentUserSource.next(user);
        }
      })
    )
     
  }

  login2(model: LoginModel) {
    let headers = new HttpHeaders({
      'x-api-version': '2.0'
        });
  let options = { headers: headers,  withCredentials: true  };
     return this.http.post<any>(
      `${this._baseUrl}account/login`, model, options).pipe(
        map((response: UserModel) => {
          const user = response;
          if (user) {
            let decryptSessionId = this.encryptDecryptService.decrypt(user.transientCode) 
            sessionStorage.setItem('decryptSessionId', JSON.stringify(decryptSessionId));
            sessionStorage.setItem('user', JSON.stringify(user));
            this.currentUserSource.next(user);
          }
        })
      )
  }


 logout(skipServerCall: boolean = false): void {
  const cleanup = () => {
    sessionStorage.removeItem('user');
    sessionStorage.clear();
    this.currentUserSource.next(null);
    this.router.navigate(['/']);
  };

  if (skipServerCall) {
    cleanup();
    return;
  }

  const timeout = setTimeout(() => {
    console.warn('Revoke token timeout — proceeding with logout.');
    cleanup();
  }, 3000); // fallback after 3 seconds

  this.revokeRefreshToken().subscribe({
    next: () => console.log('Refresh token revoked'),
    error: (err) => console.error('Error revoking refresh token', err),
    complete: () => {
      clearTimeout(timeout);
      cleanup();
    }
  });
}


  resetPassword(model:any):Observable<any>
  {
    return this.http.post<any>(this._baseUrl + 'account/ResetPassword', model);
  }

  updatePassword(model:any):Observable<any>
  {
    return this.http.post<any>(this._baseUrl + 'account/UpdatePassword', model);
  }

  forgotPassword(model: any) {
    
    this.httpClient = new HttpClient(this.httpBackend);
    return this.httpClient.post<any>(`${this._baseUrl}account/forgotPassword`, model)
  }
   
  forgotPassword2(model: any): Observable<any> {
    let options = { headers: new HttpHeaders({'x-api-version': '2.0'}) };
    this.httpClient = new HttpClient(this.httpBackend);
    return this.http.post<any>(`${this._baseUrl}account/forgotPassword`, model, options);
  }
    
  
  getUserProfile(email: string) : Observable<any>{
    
    return this.http.get<any>(this._baseUrl + 'Account/GetUserProfile?email=' + email);
  }

  getSampleFileForBulkUserRegister(): any {
    return this.http.get(
      this._baseUrl + "Account/GetDetailsForUploadUsers",
      { responseType: "blob" }
    );
  }

  getSampleFileForSiteUserMapping(): any {
    return this.http.get(
      this._baseUrl + "Account/GetDetailsForUserSiteMapped",
      { responseType: "blob" }
    );
  }
 

  UploadFileToBulkRegister(model: any): Observable<any> {
    let headers = new HttpHeaders({
      'x-api-version': '2.0'
        });
        let options = { headers: headers,  withCredentials: true  };
    return this.http.post<any>(
      this._baseUrl + "Account/UploadFileToBulkRegister",
      model, options
    );
  }

  uploadFileToUserSiteMappingApproval(model: any): Observable<any> {
    return this.http.post<any>(
      this._baseUrl + "Account/UploadFileToUserSiteMappingApproval",
      model
    );
  }
   
processUserSiteMapping(model: any): Observable<any> {
    return this.http.post<any>(
      this._baseUrl + "Account/ProcessUserSiteMapping",
      model
    );
  }

getUserSiteMappings() : Observable<any>{
  return this.http.get<any>(this._baseUrl + 'Account/GetUserSiteMappings');
}

userSiteMapChangeStatus(model: any): Observable<any> {
  return this.http.post<any>(
    this._baseUrl + "Account/UserSiteMapChangeStatus",
    model
  );
}

getUserSitesWithMappingStatus(model: any): Observable<any> {
  return this.http.post<any>(
    this._baseUrl + "Account/GetUserSitesWithMappingStatus",
    model
  );
}

getActiveUserBaseDetails() : Observable<any>{
  return this.http.get<any>(this._baseUrl + 'Account/GetActiveUserBaseDetails');
}

updateUserSiteMapping(model: any): Observable<any> {
  return this.http.post<any>(
    this._baseUrl + "Account/UpdateUserSiteMapping",
    model
  );
}

accountUnLockRequest(model: any): Observable<any> {
  let headers = new HttpHeaders({
    'x-api-version': '2.0'
      });
let options = { headers: headers };
   return this.http.post<any>(
    `${this._baseUrl}Account/AccountUnLockRequest`, model, options
   );
}
 
accountLockRequest(model: any): Observable<any> {
  let headers = new HttpHeaders({
    'x-api-version': '2.0'
      });
let options = { headers: headers };
   return this.http.post<any>(
    `${this._baseUrl}Account/AccountLockRequest`, model, options
   );
}

async validateSession(model: any): Promise<boolean> {
  let headers = new HttpHeaders({
    'x-api-version': '2.0'
  });
  let options = {
    headers: headers,
    withCredentials: true // This ensures cookies are sent with the request
  };

  try {
    const response = await this.http.post<any>(
      `${this._baseUrl}Account/ValidateSession`, model, options
    ).toPromise();

    return response.isValid === true;
  } catch (error) {
    console.error('Session validation failed:', error);
    return false;
  }
}

verifyTokenCookie() {
  let headers = new HttpHeaders({
    'x-api-version': '2.0'
      });
      let options = {
        headers: headers,
        withCredentials: true // This ensures cookies are sent with the request
      };
  return this.http.get<any>(`${this._baseUrl}account/VerifyToken`, { ...options });
}

waitForTokenCookie(maxRetries: number = 10, retryIntervalMs: number = 1000): Promise<void> {
  let attempts = 0;

  return new Promise<void>((resolve, reject) => {
    const checkToken = () => {
      // Verify if the token cookie is set
      this.verifyTokenCookie().subscribe(() => {
        // Token is present, resolve the promise and proceed
        resolve();
      }, (error) => {
        attempts++;
        if (attempts < maxRetries) {
          // Retry after a delay
          setTimeout(checkToken, retryIntervalMs);
        } else {
          // Max retries reached, reject the promise
          reject(new Error('Token was not set after multiple attempts.'));
        }
      });
    };

    // Start checking for the token
    checkToken();
  });
}


refreshToken(userId: string): Observable<any> {
  const headers = new HttpHeaders({
    'x-api-version': '2.0'
  });

  return this.http.post(
    `${this._baseUrl}account/RefreshAccessTokenWithRefreshToken`,
    { userId }, // ONLY userId now
    { headers, observe: 'response', withCredentials: true }
  ).pipe(
    tap(response => {
      // Optional: handle new session ID if needed
      const body = response.body;
      const transientCode = body?.transientCode;
      if (transientCode) {
        const user = JSON.parse(sessionStorage.getItem('user') || '{}');
        user.transientCode = transientCode;
        sessionStorage.setItem('user', JSON.stringify(user));
      }
    })
  );
}

revokeRefreshToken(): Observable<any> {
  const headers = new HttpHeaders({
    'x-api-version': '2.0'
  });

  return this.http.post<any>(`${this._baseUrl}Account/RevokeRefreshToken`, {}, { headers });
}

  updatePasswordV2(model:any):Observable<any>
  {
  let options = { headers: new HttpHeaders({
      'x-api-version': '2.0'
        }),  withCredentials: true  };
    return this.http.post<any>(this._baseUrl + 'account/UpdatePassword', model, options);
  }


}
